import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

const HighlightedText = ({
  text,
  highlight,
}: {
  text: string | null
  highlight: string | null
}) => {
  if (!highlight || !text) {
    return (
      <Typography sx={{ fontWeight: "inherit", color: "inherit" }}>
        {text}
      </Typography>
    )
  }

  const safeText = highlight.replace(/[.*+?^${}()|\\]/g, "\\$&")
  const parts = String(text).split(new RegExp(`(${safeText})`, "gi"))

  return (
    <Typography
      component="span"
      sx={{ fontWeight: "inherit", color: "inherit" }}
    >
      {parts.map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <Box component="span" key={index} sx={{ backgroundColor: "#fff2cc" }}>
            {part}
          </Box>
        ) : (
          part
        ),
      )}
    </Typography>
  )
}

export { HighlightedText }
